import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { findInArray, getValueProperty, memoize, removeAccents, scrollTop, setValueProperty } from '../../shared/helpers/functions.helpers';
import { IFindSolicitationResponseObject } from '../../shared/models/solicitation-models/solicitation/SolicitationModel';
import { ESortDirection, sortArrayObject } from '../../shared/helpers/functions.helpers';
import { CatalogService, EPersonType } from '../../shared/services/catalogs/catalog.service';
import { CopyService } from '../../shared/services/copies/copy.service';
import { ValidatorFormFieldService, ValidatorsPatterns } from '../../shared/services/forms/validator-form-field.service';
import { EQueryType, FindNotFoundException, FindSolicitationsService, IQueryParamsFindSolicitation } from '../../shared/services/solicitations/find-solicitations.service';
import { EDocumentTypeId } from '../form-solicitation-basic-data/form-solicitation-basic-data.component';
import { FileService, IRequestFile, IFieldParameterRequest } from '../../shared/services/onbase/file-service.service';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { UnicodePipe } from '../../shared/pipe/unicode.pipe';

import moment from "moment";
import { BaseComponent } from '../../shared/components/base-component';
import { ApplicationService } from '../../shared/services/application/application.service';
import { EVENT } from '../../shared/constants/dali.constants';
import { camelCase } from 'lodash';

export enum EStatusFindRequest {
  FOUND = 'found',
  ERROR = 'error',
  NOT_FOUND = 'not_found'
}

export enum EActionDialog {
  CANCEL = 'action1',
  OK = 'action2'
}

@Component({
  selector: 'app-form-solicitation-search',
  templateUrl: './form-solicitation-search.component.html',
  styleUrls: ['./form-solicitation-search.component.scss']
})
export class FormSolicitationSearchComponent extends BaseComponent implements OnInit {

  form: FormGroup = this.fb.group({});

  formFiles: FormGroup = this.fb.group({});
  showModalUploadFiles = false;

  documentTypeList: any[] = [];

  /**
  * Permite mostrar en pantalla el dialogo para consultar un nuevo cliente
  */
  showDialogConfirm = false;
  showDialogConfirmFilter = false;
  actionFilter = '';
  actionFilterTemp = '';

  isLoading = false;

  modalAShow = false;

  captionSubtitle: string = "";

  close_date = "";
  close_cause = "";


  /**
 * Contiene los textos y etiquetas
 */
  CONTENT_BOUNDS: any[] | any;

  @Output()
  findRequest: EventEmitter<any> = new EventEmitter<any>();

  isNit = false;


  readonly ID_TYPE_DOCUMENT_NIT = EDocumentTypeId.NIT;
  readonly ID_TYPE_DOCUMENT_CC = EDocumentTypeId.CC;
  readonly ID_TYPE_DOCUMENT_CE = EDocumentTypeId.CE;
  readonly ID_TYPE_DOCUMENT_PA = EDocumentTypeId.PA;
  readonly ID_TYPE_DOCUMENT_SE = EDocumentTypeId.SE;
  readonly ID_TYPE_DOCUMENT_TI = EDocumentTypeId.TI;
  readonly ID_TYPE_DOCUMENT_PD = EDocumentTypeId.PD;

  displayedColumns: string[] = [
    'detalle',
    /*'tipoIdentificacion', 'nroIdentificacion', */
    'numeroRadicacion',
    'fechaRadicacion',
    'descripcionSolicitud',
    'estadoSolicitud',
    //'fechaCierre',
    //'descripcionCierre',
    //'causaCierre',
  ];
  displayedColumnsDetail: string[] = ['fecha', 'descripcion', 'procesoActual', 'estadoActual'];
  data: any;
  dataDetail: any;

  //Paginator
  pageIndex: number = 0;
  pageIndexDetail: number = 0;
  pageSize: number = 10;

  statusClose = 'Cerrado';
  configUpload: any

  currentItem: any;

  dataLoadFilesError = false;
  dataLoadFilesSuccess = false;
  useCaptcha = false;
  requiredAllFields = false;

  private _solicitationSettings: any = [];

  actionToken = 'search';

  constructor(
    private readonly fb: FormBuilder,
    private readonly cps: CopyService,
    private readonly _catalog: CatalogService,
    private readonly controlContainer: ControlContainer,
    public validatorFormField: ValidatorFormFieldService,
    private readonly findSolicitation: FindSolicitationsService,
    private readonly _file: FileService,
    private readonly _link: LinkupService,
    public readonly _app: ApplicationService
  ) {
    super(_app, _link, "form-solicitation-search")
  }

  ngOnInit(): void {
    this.loadStaticValues();
    this.initControls()
      .finally(() => {
        this.loadData();
      });
      scrollTop();
  }

  /**
   * Permite la carga de textos y listas estaticas
   */
  async loadStaticValues() {
    await super.loadStaticValues();
    await this._app.recaptchaToken({ action: this.actionToken });
    this.requiredAllFields = this.getSetting("services", "requiredAllFields", false);
    this.useCaptcha = this.getSetting("services", "useCaptcha", false);
    this.CONTENT_BOUNDS = await this.cps.getCopy("form-solicitation-search");
    this.documentTypeList = await this._catalog.documentTypes;
    this.statusClose = getValueProperty(this.CONTENT_BOUNDS, 'status_close', 'Cerrado');
    this._solicitationSettings = await this._catalog.getResourceCatalogSolicitations("solicitation_settings");
    this.configUpload = { 'caption_count': getValueProperty(this.CONTENT_BOUNDS, 'modals.upload.caption', '') }
  }

  /**
   * Encargado de consultar los de las solicitudes asociadas al cliente
   */
  async findRequestEvent() {

    if(this.form.invalid){
      return
    }

    this.requestListDetail.clear();
    this.requestListDetailResult.clear();
    this.requestListDetail.reset();
    this.requestListDetailResult.reset();
    this.requestList.clear();
    this.requestListResult.clear();
    this.pageSize = 10;
    this.pageIndex = 0;

    let isValidCaptcha = true;

    const documentType = getValueProperty(this.form.get('document_type_temp'), 'value', '');
    const documentNumber = getValueProperty(this.form.get('document_number_temp'), 'value', '');
    const pqrNumber = getValueProperty(this.form.get('pqr_number'), 'value', '');

    if (this.dataLoaded.value) {
      this.showDialogConfirm = true;
    }/*else{
      isValidCaptcha = await this._app.validateRecaptcha(this.actionToken);
      this.form.patchValue({
        document_type: documentType,
        document_number: documentNumber
      });
    } */
    
    if (!this.showDialogConfirm && isValidCaptcha) {
      this.isLoading = true;
      

      let eventResponse: any = {
        status: 'NOT_FOUND',
        documentNumber,
        documentType,
        data: undefined
      }

      try {
        let queryParams: IQueryParamsFindSolicitation = {
          query_type: (pqrNumber && !this.requiredAllFields) ? EQueryType.PQR : EQueryType.DOCUMENT,
          document_type: documentType,
          document_number: documentNumber,
          pqr: pqrNumber,
          solicitation_application: ''
        };
        let documentTypeSelected = findInArray(this.documentTypeList, "id", getValueProperty(this.form.get('document_type_temp'), 'value'));
        let word = 'No seleccionado';
        if (getValueProperty(documentTypeSelected, 'name', false)) {
          word = getValueProperty(documentTypeSelected, 'name');
          word = camelCase(word);
          word = word[0].toUpperCase() + word.substring(1);;
        }

        let eventSetting = this.getSetting("analytics", "trackEvent.e1", "");
        let pageSetting = this.getSetting("analytics", "pageLoad", "");
        let events = [
          {
            "name": "{EVENT.pv7E1setData.pv7E1transactionProductDetails.path}",
            "value": word
          },
          {
            "name": "{EVENT.pv7E1setData.pv7E1transactionName.path}",
            "value": EVENT.pv7E1setData.pv7E1transactionName.value
          },
          {
            "name": "{EVENT.pv7E1setData.pv7E1transactionProductCategory.path}",
            "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
          }
        ]
        setValueProperty(eventSetting, "events", events);
        this.onEvent(eventSetting);
        const data = await this.findSolicitation.send(queryParams);
        this.data = getValueProperty(data, "data", []);
        this.dataDetail = getValueProperty(data, "data", []);
        if (data.hasOwnProperty("code")) {
          throw new Error(getValueProperty(data, "message", "Error"))
        }
        if (this.data.length == 0) {
          throw new FindNotFoundException;
        }
        this.loadData();
        this.loadDataDetail();

        eventResponse.data = data;
        this.form.patchValue({
          document_type: documentType,
          document_number: documentNumber,
          data_exists: true,
          data_loaded: true,
          data_error: false
        });

        eventResponse.status = 'FOUND';

      } catch (error) {
        let eventSetting = this.getSetting("analytics", "trackEvent.e2", "");
        let pageSetting = this.getSetting("analytics", "pageLoad", "");
        let events = [
          {
            "name": "{EVENT.pv7E2setData.pv7E2transactionName.path}",
            "value": EVENT.pv7E2setData.pv7E2transactionName.value
          },
          {
            "name": "{EVENT.pv7E2setData.pv7E2transactionProductCategory.path}",
            "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
          }
        ]
        setValueProperty(eventSetting, "events", events);
        let code = getValueProperty(error, "code", "NotAvailable");
        let word = camelCase(getValueProperty(error, "message", "ServiceNotAvailable"));
        word = word[0].toUpperCase() + word.substring(1);
        setValueProperty(eventSetting, "errorName", code + " | " + word);
        this.onEvent(eventSetting);
        if (error instanceof FindNotFoundException) {
          eventResponse.status = EStatusFindRequest.NOT_FOUND;

          this.form.patchValue({
            data_exists: false,
            data_loaded: true,
            data_error: false
          },
            {
              onlySelf: true,
              emitEvent: false
            });

        } else {
          eventResponse.status = EStatusFindRequest.ERROR;
          this.form.patchValue({
            data_exists: false,
            data_loaded: false,
            data_error: true
          },
            {
              onlySelf: true,
              emitEvent: false
            });
        }
      }
      await this._app.recaptchaToken({ action: this.actionToken });
      this.isLoading = false;
      this.findRequest.emit(eventResponse);
    } else if (!isValidCaptcha) {
      console.error('Captcha is invalid');
      await this._app.recaptchaToken({ action: this.actionToken });
    }
  }

  /**
   * Permite inicializar los campos del formulario en el componente
   */
  async initControls() {
    const form = this.controlContainer.control as FormGroup;
    if (form) {
      this.form = form;
    }
    const PATTERN_ALPHANUMERIC = await this.validatorFormField.validatorPattern(ValidatorsPatterns.ALPHANUMERIC);

    this.form.addControl("document_type_temp", this.fb.control('', [Validators.required]));
    this.form.addControl("document_number_temp",
      this.fb.control('', [
        Validators.required,
        Validators.pattern(PATTERN_ALPHANUMERIC),
        Validators.minLength(2),
        Validators.maxLength(12)
      ]));
    this.form.addControl("document_type", this.fb.control('', []));
    this.form.addControl("document_number", this.fb.control('', []));
    this.form.addControl("pqr_number", this.fb.control('', [Validators.required]));

    this.form.addControl("data_exists", this.fb.control(false, []));
    this.form.addControl("data_loaded", this.fb.control(false, []));
    this.form.addControl("data_error", this.fb.control(false, []));

    this.form.addControl("requestList", this.fb.array([]));
    this.form.addControl("requestListResult", this.fb.array([]));

    this.form.addControl("requestListDetail", this.fb.array([]));
    this.form.addControl("requestListDetailResult", this.fb.array([]));
    this.formFiles.addControl('files', this.fb.array([], [Validators.required, Validators.minLength(1)]));

    this.form.updateValueAndValidity();
    await this.registerDynamicValidators();

  }

  /**
   * Permite controlar las validaciones segun los datos ingresados por el usuario
   */
  async registerDynamicValidators() {

    const PATTERN_CEDULA = await this.validatorFormField.validatorPattern(ValidatorsPatterns.CEDULA);
    const PATTERN_NIT = await this.validatorFormField.validatorPattern(ValidatorsPatterns.NIT);
    const PATTERN_EXTRANJERIA = await this.validatorFormField.validatorPattern(ValidatorsPatterns.EXTRANJERIA);
    const PATTERN_PASAPORTE = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PASAPORTE);
    const PATTERN_PQR = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PQR);
    const PATTERN_SE = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PATTERN_SOC_EXT_SIN_NIT_COL);
    const PATTERN_TI = await this.validatorFormField.validatorPattern(ValidatorsPatterns.TI);
    const PATTERN_PD = await this.validatorFormField.validatorPattern(ValidatorsPatterns.PD);

    const documentType = this.form.get('document_type_temp');
    const documentNumber = this.form.get('document_number_temp');
    const pqrNumber = this.form.get('pqr_number');
    if (documentType && documentNumber && pqrNumber) {
      pqrNumber.addValidators([Validators.pattern(PATTERN_PQR)]);
      documentNumber.disable();
      documentType.valueChanges.subscribe(value => {
        pqrNumber.clearValidators();
        if (value && !this.requiredAllFields) {
          pqrNumber.setErrors(null);
          pqrNumber.setValue(null);
          pqrNumber.disable({ emitEvent: false });
          documentNumber.addValidators([Validators.required]);
          documentNumber.enable();
        } else if (!this.requiredAllFields) {
          pqrNumber.addValidators([Validators.required]);
          pqrNumber.addValidators([Validators.pattern(PATTERN_PQR)]);
          pqrNumber.enable({ emitEvent: false });
          documentNumber.setErrors(null);
          documentNumber.setValue(null);
          documentNumber.disable({ emitEvent: false });
        }
        else {
          pqrNumber.addValidators([Validators.required]);
          pqrNumber.addValidators([Validators.pattern(PATTERN_PQR)]);
          pqrNumber.enable({ emitEvent: false });
          documentNumber.addValidators([Validators.required]);
          documentNumber.enable();
        }

        this.isNit = false;
        if (value === this.ID_TYPE_DOCUMENT_CC) {
          documentNumber.addValidators([Validators.pattern(PATTERN_CEDULA)]);
        } else if (value === this.ID_TYPE_DOCUMENT_CE) {
          documentNumber.addValidators([Validators.pattern(PATTERN_EXTRANJERIA)]);
        } else if (value === this.ID_TYPE_DOCUMENT_PA) {
          documentNumber.addValidators([Validators.pattern(PATTERN_PASAPORTE)]);
        } else if (value === this.ID_TYPE_DOCUMENT_NIT) {
          documentNumber.addValidators([Validators.pattern(PATTERN_NIT)]);
          this.isNit = true;
        } else if (value === this.ID_TYPE_DOCUMENT_SE) {
          documentNumber.addValidators([Validators.pattern(PATTERN_SE)]);
        } else if (value === this.ID_TYPE_DOCUMENT_TI) {
          documentNumber.addValidators([Validators.pattern(PATTERN_TI)]);
        } else if (value === this.ID_TYPE_DOCUMENT_PD) {
          documentNumber.addValidators([Validators.pattern(PATTERN_PD)]);
        }
        documentNumber.updateValueAndValidity();
      });

      pqrNumber.valueChanges.subscribe(value => {
        documentType.clearValidators();
        documentNumber.clearValidators();
        if (value && !this.requiredAllFields) {
          documentType.setErrors(null);
          documentType.setValue(null);
          documentType.disable({ emitEvent: false });
          documentNumber.setErrors(null);
          documentNumber.setValue(null);
          documentNumber.disable({ emitEvent: false });
        } else {
          documentType.addValidators([Validators.required]);
          documentType.enable({ emitEvent: false });
          documentNumber.addValidators([Validators.required]);
        }
      });
    }
  }

  /**
   * Permite reactivar los controles segun la interacción del usuario
   * @param action
   */
  onClickChangeFilters(action: string) {
    if (this.dataLoaded.value && this.actionFilter != action) {
      this.showDialogConfirmFilter = true;
      this.actionFilterTemp = action;
    } else {
      this.actionFilter = action;
      const documentType = this.form.get('document_type_temp');
      const documentNumber = this.form.get('document_number_temp');
      const pqrNumber = this.form.get('pqr_number');

      if (documentType && documentNumber && pqrNumber) {
        if (action == 'identification' && documentType.disabled) {
          pqrNumber.setErrors(null);
          pqrNumber.setValue(null);
          pqrNumber.disable({ emitEvent: false });
          documentType.enable({ emitEvent: false });
        } else if (action == 'pqr_number' && pqrNumber.disabled) {
          documentType.setErrors(null);
          documentType.setValue(null);
          documentType.disable({ emitEvent: false });
          documentNumber.setErrors(null);
          documentNumber.setValue(null);
          documentNumber.disable({ emitEvent: false });
          pqrNumber.enable({ emitEvent: false });
        }
      }
    }
  }

  /**
   * Permite obtener los mensajes de error
   * @param control
   * @returns
   */
  @memoize()
  async getMessageError(control: { label: string, formControlName: string }, errors: any) {
    const { label, formControlName } = control;
    const formControl = this.form.get(formControlName);
    if (formControl) {
      return this.validatorFormField.getMessageError(label, formControl, errors);
    } else {
      return '';
    }
  }

  /**
 * Permite obtener la referencia al control data_loaded
 */
  get dataLoaded(): FormControl {
    return this.form.get('data_loaded') as FormControl;
  }

  /**
   * Permite obtener la referencia al control data_loaded
   */
  get dataExists(): FormControl {
    return this.form.get('data_exists') as FormControl;
  }

  /**
   * Permite obtener la referencia al control data_error
   */
  get dataError(): FormControl {
    return this.form.get('data_error') as FormControl;
  }

  /**
  * Permite capturar la respuesta del usuario y continuar el proceso segun la acción realizada
  * @param event
  */
  async dialogButtonClicked(event: any) {
    this.showDialogConfirm = false;
    if (event.type === EActionDialog.OK) {
      const documentType = this.form.get('document_type_temp')?.value;
      const documentNumber = this.form.get('document_number_temp')?.value;
      const pqrNumber = this.form.get('pqr_number')?.value;

      this.form.reset({
        document_type: documentType,
        document_number: documentNumber,
        document_type_temp: documentType,
        document_number_temp: documentNumber,
        pqr_number: pqrNumber,
        data_exists: false,
        data_loaded: false,
        data_error: false
      }, { onlySelf: true, emitEvent: false });


      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control) {
          control.setErrors(null);
        }
      });

      this.form.markAsUntouched();
      this.form.markAsPristine();
      this.form.updateValueAndValidity();
      await this.findRequestEvent();
    } else {
      const documentType = this.form.get('document_type')?.value;
      const documentNumber = this.form.get('document_number')?.value;
      this.form.patchValue({
        document_type_temp: documentType,
        document_number_temp: documentNumber
      });
    }

  }

  /**
 * Permite capturar la respuesta del usuario y continuar el proceso segun la acción realizada
 * @param event
 */
  async dialogButtonClickedFilter(event: any) {
    this.showDialogConfirmFilter = false;
    if (event.type === EActionDialog.OK) {
      this.actionFilter = this.actionFilterTemp;
      this.form.reset({
        data_exists: false,
        data_loaded: false,
        data_error: false
      }, { onlySelf: true, emitEvent: false });
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control) {
          control.setErrors(null);
        }
      });
      this.form.markAsUntouched();
      this.form.markAsPristine();
      this.form.updateValueAndValidity();
      this.onClickChangeFilters(this.actionFilter);
    }
  }

  /**
  * Permite obtener la lista modificada
  */
  get requestList(): FormArray {
    return this.form.get('requestList') as FormArray;
  }

  /**
  * Permite obtener la lista inicial
  */
  get requestListResult(): FormArray {
    return this.form.get('requestListResult') as FormArray;
  }

  /**
  * Permite obtener la lista inicial del detalle
  */
  get requestListDetailResult(): FormArray {
    return this.form.get('requestListDetailResult') as FormArray;
  }

  /**
  * Permite obtener la lista modificada del detalle
  */
  get requestListDetail(): FormArray {
    return this.form.get('requestListDetail') as FormArray;
  }

  /**
  * Itera los datos del servicio y manda a paginar
  */
  loadData() {
    if (this.data && Array.isArray(this.data)) {
      for (let dataObj of this.data) {
        this.addRequest(dataObj);
      }
      this.onPageChange({ pageSize: this.pageSize, pageIndex: this.pageIndex });
    }
  }

  /**
  * Mapea los campos que retorna el servicio a la lista de la tabla
  */
  async addRequest(data: IFindSolicitationResponseObject) {
    let requestData = this.fb.group({
      tipoIdentificacion: this.fb.control(getValueProperty(data, "document_type", null)),
      numeroIdentificacion: this.fb.control(getValueProperty(data, "document_number", null)),
      numeroRadicacion: this.fb.control(getValueProperty(data, "solicitation_id", null)),
      fechaRadicacion: this.fb.control(getValueProperty(data, "trn_dt", null)),
      descripcionSolicitud: this.fb.control(getValueProperty(data, "solicitation_desc", null)),
      estadoSolicitud: this.fb.control(getValueProperty(data, "solicitation_status_desc", null)),
      fechaCierre: getValueProperty(data, "solicitation_status_desc", null) == 'Cerrado' ? this.fb.control(getValueProperty(data, "close_dt", null)) : '',
      descripcionCierre: this.fb.control(getValueProperty(data, "solicitation_close_desc", null)),
      causaCierre: this.fb.control(getValueProperty(data, "solicitation_close_category", null)),
      subtype: this.fb.control(getValueProperty(data, "solicitation_code_category", null))
    });

    this.requestListResult.push(requestData);
  }

  /**
  * Pagina los datos de la tabla
  * @param $event
  */
  async onPageChange($event: any) {
    this.requestList.clear();
    this.pageSize = $event.pageSize;
    this.pageIndex = $event.pageIndex;

    let values = getValueProperty(this.requestListResult, "value", []);
    let segmento = values.slice($event.pageSize * $event.pageIndex, $event.pageSize * ($event.pageIndex + 1));
    for (let dataObj of segmento) {
      let requestData = this.fb.group({
        tipoIdentificacion: this.fb.control(getValueProperty(dataObj, "tipoIdentificacion", null)),
        numeroIdentificacion: this.fb.control(getValueProperty(dataObj, "numeroIdentificacion", null)),
        numeroRadicacion: this.fb.control(getValueProperty(dataObj, "numeroRadicacion", null)),
        fechaRadicacion: this.fb.control(getValueProperty(dataObj, "fechaRadicacion", null)),
        descripcionSolicitud: this.fb.control(getValueProperty(dataObj, "descripcionSolicitud", null)),
        estadoSolicitud: this.fb.control(getValueProperty(dataObj, "estadoSolicitud", null)),
        fechaCierre: this.fb.control(getValueProperty(dataObj, "fechaCierre", null)),
        descripcionCierre: this.fb.control(getValueProperty(dataObj, "descripcionCierre", null)),
        causaCierre: this.fb.control(getValueProperty(dataObj, "causaCierre", null)),
        subtype: this.fb.control(getValueProperty(dataObj, "subtype", null))
      });

      this.requestList.push(requestData);
    }
  }

  /**
   * Permite procesar el evento de ordenamiento de datos por columna
   * @param event
   */
  sortData(event: { columnName: string, direction: ESortDirection }) {
    const data = this.requestList.value;
    let dataSort = sortArrayObject(data, event.columnName, event.direction);
    this.requestList.patchValue(dataSort);
  }

  @memoize()
  homologarDocumentType(documentType: String) {
    let result = null;
    if (documentType === "CC") {
      result = this.ID_TYPE_DOCUMENT_CC;
    } else if (documentType === "NIT" || documentType === "NT") {
      result = this.ID_TYPE_DOCUMENT_NIT;
    } else if (documentType === "CE") {
      result = this.ID_TYPE_DOCUMENT_CE;
    } else if (documentType === "PA") {
      result = this.ID_TYPE_DOCUMENT_PA;
    } else if (documentType === "SE") {
      result = this.ID_TYPE_DOCUMENT_SE;
    } else if (documentType === "TI") {
      result = this.ID_TYPE_DOCUMENT_TI;
    } else if (documentType === "PD") {
      result = this.ID_TYPE_DOCUMENT_PD;
    }
    return result;
  }

  modal(data: any) {
    let eventSetting = this.getSetting("analytics", "trackEvent.e3", "");
    let pageSetting = this.getSetting("analytics", "pageLoad", "");
    let events = [
      {
        "name": "{EVENT.pv7E3setData.pv7E3transactionName.path}",
        "value": EVENT.pv7E3setData.pv7E3transactionName.value
      },
      {
        "name": "{EVENT.pv7E3setData.pv7E3transactionProductCategory.path}",
        "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
      }
    ]
    setValueProperty(eventSetting, "events", events);
    this.onEvent(eventSetting);
    this.close_date = getValueProperty(data, "fechaCierre", "");
    this.close_cause = getValueProperty(data, "causaCierre", "");
    this.findRequestDetail(data.numeroRadicacion)
    this.onShowModal();
  }

  /**
   * Establece el valor de modalAShow a verdadero para mostrar la modal de tipos de solicitud en pantalla
   */
  onShowModal() {
    this.modalAShow = true
  };

  /**
   * Se ejecuta cuando se emite el evento de cierre de la modal
   * @param event
   */
  onCloseModal(event: any) {
    this.modalAShow = false;
  }

  async findRequestDetail(numeroRadicacion: string) {
    this.requestListDetail.clear();
    this.requestListDetailResult.clear();
    this.requestListDetail.reset();
    this.requestListDetailResult.reset();

    this.isLoading = true;
    const documentType = this.form.get('document_type_temp')?.value;
    const documentNumber = this.form.get('document_number_temp')?.value;
    let eventResponse: any = {
      status: 'NOT_FOUND',
      documentNumber,
      documentType,
      data: undefined
    }

    this.captionSubtitle = numeroRadicacion;

    try {
      let queryParams: IQueryParamsFindSolicitation = {
        query_type: EQueryType.PQR,
        document_type: '',
        document_number: '',
        pqr: numeroRadicacion,
        solicitation_application: ''
      };

      const dataDetail = await this.findSolicitation.send(queryParams);

      this.dataDetail = getValueProperty(dataDetail, "data", []);
      if (dataDetail.hasOwnProperty("code")) {
        throw new Error(getValueProperty(dataDetail, "message", "Error"))
      }
      if (this.dataDetail.length == 0) {
        throw new FindNotFoundException;
      }
      this.loadDataDetail();

      eventResponse.data = dataDetail;
      this.form.patchValue({
        data_exists: true,
        data_loaded: true,
        data_error: false
      });

      eventResponse.status = 'FOUND';

    } catch (error) {
      if (error instanceof FindNotFoundException) {
        eventResponse.status = EStatusFindRequest.NOT_FOUND;

        this.form.patchValue({
          data_exists: false,
          data_loaded: true,
          data_error: false
        },
          {
            onlySelf: true,
            emitEvent: false
          });

      } else {
        eventResponse.status = EStatusFindRequest.ERROR;
        this.form.patchValue({
          data_exists: false,
          data_loaded: false,
          data_error: true
        },
          {
            onlySelf: true,
            emitEvent: false
          });
      }

    }
    this.isLoading = false;
  }

  /**
  * Itera los datos del servicio y manda a paginar
  */
  loadDataDetail() {
    if (this.dataDetail && Array.isArray(this.dataDetail)) {
      for (let dataObj of this.dataDetail) {
        this.addRequestDetail(dataObj);
      }
      this.onPageChangeDetail({ pageSize: this.pageSize, pageIndex: this.pageIndexDetail });
    }
  }

  /**
  * Mapea los campos que retorna el servicio a la lista de la tabla
  */
  async addRequestDetail(data: IFindSolicitationResponseObject) {
    let requestDataDetail = this.fb.group({
      estadoGlobal: this.fb.control(getValueProperty(data, "business_status", null)),
      descripcion: this.fb.control(getValueProperty(data, "description", null)),
      fecha: this.fb.control(getValueProperty(data, "pqr_date", null)),
      estadoNegocio: this.fb.control(getValueProperty(data, "solicitation_status_desc", null)),
    });

    this.requestListDetailResult.push(requestDataDetail);
  }

  /**
  * Pagina los datos de la tabla
  * @param $event
  */
  async onPageChangeDetail($event: any) {

    this.requestListDetail.clear();
    this.pageSize = $event.pageSize;
    this.pageIndexDetail = $event.pageIndex;

    let values = getValueProperty(this.requestListDetailResult, "value", []);
    let segmento = values.slice($event.pageSize * $event.pageIndex, $event.pageSize * ($event.pageIndex + 1));
    for (let dataObj of segmento) {
      let requestData = this.fb.group({
        estadoGlobal: this.fb.control(getValueProperty(dataObj, "estadoGlobal", null)),
        descripcion: this.fb.control(getValueProperty(dataObj, "descripcion", null)),
        fecha: this.fb.control(getValueProperty(dataObj, "fecha", null)),
        estadoNegocio: this.fb.control(getValueProperty(dataObj, "estadoNegocio", null))
      });

      this.requestListDetail.push(requestData);
    }
  }

  /**
   * Permite procesar el evento de ordenamiento de datos por columna
   * @param event
   */
  sortDataDetail(event: { columnName: string, direction: ESortDirection }) {
    const data = this.requestListDetail.value;

    let dataSort = sortArrayObject(data, event.columnName, event.direction);
    this.requestListDetail.patchValue(dataSort);

  }

  onUploadFiles(item: any) {
    let eventSetting = this.getSetting("analytics", "trackEvent.e4", "");
    let pageSetting = this.getSetting("analytics", "pageLoad", "");
    let events = [
      {
        "name": "{EVENT.pv7E4setData.pv7E4transactionName.path}",
        "value": EVENT.pv7E4setData.pv7E4transactionName.value
      },
      {
        "name": "{EVENT.pv7E4setData.pv7E4transactionProductCategory.path}",
        "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
      }
    ]
    setValueProperty(eventSetting, "events", events);
    this.onEvent(eventSetting);

    this.showModalUploadFiles = true;
    this.currentItem = item;
    this.dataLoadFilesError = false;
    this.dataLoadFilesSuccess = false;
  }

  /**
   * Se ejecuta cuando se emite el evento de cierre de la modal
   * @param event
   */
  async onCloseModalUploadFiles(event: any) {
    if (event.action == "1") {
      this.isLoading = true;
      await this.processFiles(this.formFiles.value);
      let eventSetting = this.getSetting("analytics", "trackEvent.e5", "");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
          "name": "{EVENT.pv7E5setData.pv7E5transactionName.path}",
          "value": EVENT.pv7E5setData.pv7E5transactionName.value
        },
        {
          "name": "{EVENT.pv7E5setData.pv7E5transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        }
      ];
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);
    }
    this.fileList.clear();
    this.isLoading = false;

    this.showModalUploadFiles = false;
  }

  get fileList() {
    return this.formFiles.get('files') as FormArray;
  }

  async processFiles(formFile: any) {

    let fileList = formFile.files;
    let subtypeCode = getValueProperty(this.currentItem, 'subtype');

    const FILE_SETTINGS = getValueProperty(await this._link.settings, 'onbase.OPTIONS.data', {});

    let catalogDocuments = await this._catalog.documentTypes;
    let catalogType = await this._catalog.customerTypes;
    let subtype = await this._catalog.getCelulaTypeSubtypeById(subtypeCode);
    let type = await this._catalog.getCelulaTypeById(getValueProperty(subtype, 'typeId', ''));
    let cellule = await this._catalog.getCelulaById(getValueProperty(type, 'celulaId', ''));

    let customer = findInArray(catalogType, 'id', this.isNit ? EPersonType.PERSON_TYPE_JUR : EPersonType.PERSON_TYPE_NAT);

    const documentTypeId = getValueProperty(this.form.value, 'document_type');
    const documentTypeData = findInArray(catalogDocuments, 'id', documentTypeId);

    const documentTypeParameters = getValueProperty(documentTypeData, 'parameters', []);
    const codeOnBaseParameter = findInArray(documentTypeParameters, 'key', 'code_onbase');
    const codeParameter = findInArray(documentTypeParameters, 'key', 'code');

    /* 
    * Se realiza validación de parametro homologo para onbase en 
    * caso de no encontrarse el valor se envia la homologacion 
    * del codigo para sqr y si no existe ninguno de los dos se 
    * envia el identificador del tipo de documento ej. 1
    */
    let document = getValueProperty(codeOnBaseParameter, 'value', getValueProperty(codeParameter, 'value', documentTypeId));


    /*const documentTypeData = findInArray(catalogDocuments, 'id', getValueProperty(this.form.value, 'document_type'));

    let unicode = new UnicodePipe();
    let documentType = unicode.transform(getValueProperty(documentTypeData, 'name', ''));
    let document = removeAccents(`${documentType}`);*/

    const dependenceId = getValueProperty(FILE_SETTINGS, 'dependence_id');
    const processName = getValueProperty(FILE_SETTINGS, 'process_name');

    const transactionCode = getValueProperty(this.currentItem, 'numeroRadicacion');
    const solicitationId = getValueProperty(this.currentItem, 'numeroRadicacion');
    let indexFileProcess = 0;

    let fieldParameter: IFieldParameterRequest = {
      client: {
        person_type: getValueProperty(customer, 'onbase')
      },
      document: {
        type: document,
        number: getValueProperty(this.form.value, 'document_number'),
        type_id: documentTypeId
      },
      solicitation: {
        solicitation_id: transactionCode,
        client_name: 'Retoma',
        solicitation_id_pqr: solicitationId,
        validate_mimetype: 'true',
        solicitation_application: this._app.currentApplication
      },
      additional_information: {
        key: getValueProperty(cellule, 'name', ''),
      }
    };

    let time = moment().unix();
    const filesData: Array<IRequestFile> = [];
    for (let fileItem of fileList) {
      const fileId = `${transactionCode}_${time}_${++indexFileProcess}`;
      filesData.push({
        dependence_id: dependenceId,
        document_type: getValueProperty(fileItem, 'settings.id', 0),
        process_name: processName,
        file_id: fileId,
        file: fileItem.file,
        file_extension: getValueProperty(fileItem, 'settings.type', ""),
        field_parameter: fieldParameter,
      });
    }
    try {
      await this._file.send(filesData);
      this.dataLoadFilesSuccess = true;
    } catch (error) {
      this.dataLoadFilesSuccess = false;
      this.dataLoadFilesError = true;
    }
    scrollTop();
  }

  isVisible(item: any) {
    let resultOnbase = this._solicitationSettings.filter((item: any) => item.parent_business_id === "STATUS_PQR");
    if (item.estadoSolicitud === this.statusClose) {
      let validationFileClose = resultOnbase.filter((value: any) => value.business_id === "STATUS_PQR_CLOSE");
      validationFileClose = findInArray(validationFileClose[0].parameters, "key", "can_upload_file");
      return getValueProperty(validationFileClose, 'value', false) === "true";
    }
    else {
      let validationFileOpen = resultOnbase.filter((value: any) => value.business_id === "STATUS_PQR_OPEN");
      validationFileOpen = findInArray(validationFileOpen[0].parameters, "key", "can_upload_file");
      return getValueProperty(validationFileOpen, 'value', false) === "true";
    }
  }
}

